import loadable from "@loadable/component";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { queryClient } from "../../router/RunsheetRouter";
const EditRunsheetComponent = loadable(
  () => import("../../components/Runsheet/SwitchTab")
);
const EditRunsheet = () => {
  const { id } = useParams();
  const [isactive, setISactive] = useState("all");
  const [searchParams, setSearchParms] = useSearchParams();
  const [defaultValue, setDefaultValue] = useState(null);

  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`runsheet-${id}`],
    url: `${APIS.RUNSHEET}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`runsheet-${id}`, "runsheet"],
    navigateURL: "",
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`runsheet-${id}`, "runsheet"],
      navigateURL: "",
    });

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["runsheet-items"],
    navigateURL: "",
  });
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-runsheet-items"],
  });
  const { data: gridData, isLoading: isStattusDataLoading } = useGetHook({
    queryKey: [`runsheet-status`],
    url: `${APIS.RUNSHEET_STATUS}`,
    params: {
      is_active: true,
    },
  });
  const { mutateAsync: removeitems, isPostLoading: isRemoved } = usePostHook({
    queryKey: [`runsheet-items-${isactive}`],
    navigateURL: "",
  });
  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.RUNSHEET}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.RUNSHEET}${id}/toggle-is-active/`;

    try {
      const res = await toggleMarkAsDone({ url, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleMarkAsUnDone = async (values: any, setError: any) => {
    const url = `${APIS.RUNSHEET}${id}/`;
    const formData = {
      is_active: true,
    };
    try {
      const res = await toggleMarkAsDone({ url, formData, setError });
      if (res?.status === 200) {
        refetch();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: any,
    setError: any
  ) => {
    const url = `${APIS.RUNSHEET_ITEMS}`;
    let formData = {
      status_id: statusId,
      manifest: id,
      tracking_number: consignmentId,
    };

    try {
      const res = await attachConsignmentMutateAsync({
        url,
        formData,
        setError,
      });
      if (res?.status === 201) {
        queryClient.invalidateQueries({
          queryKey: [`runsheet-items-${isactive}`],
          refetchType: "active",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handlecheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.RUNSHEET}${id}/receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      await checkConsignmentsMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handlePrint = async () => {
    const url = `${APIS.RUNSHEET}${id}/print-pdf-manifest/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };
  const handleRemove = async (itemsId: any, statusId: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.RUNSHEET_ITEMS}remove-items/`;
    let formData = {
      items: itemsId,
      status: statusId,
    };
    try {
      const res = await removeitems({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Runsheet
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditRunsheetComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          handleAttachConsignment={handleAttachConsignment}
          handlePrint={handlePrint}
          handleToggleMarkAsDone={handleToggleMarkAsDone}
          handleRemove={handleRemove}
          isRemoved={isRemoved}
          isPrintLoading={isPrintLoading}
          handlecheckConsignments={handlecheckConsignments}
          gridData={gridData}
          handleStatusChange={handleStatusChange}
          defaultValue={defaultValue}
          isMarkAsDoneLoading={isMarkAsDoneLoading}
          id={id}
          setISactive={setISactive}
          handleToggleMarkAsUnDone={handleToggleMarkAsUnDone}
          isactive={isactive}
        />
      )}
    </>
  );
};
export default EditRunsheet;
